/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Answer { 
    result?: Answer.ResultEnum;
    type?: Answer.TypeEnum;
    rating?: number;
    answer?: string;
}
export namespace Answer {
    export type ResultEnum = 'SUCCESS' | 'FAILURE' | 'WARNING';
    export const ResultEnum = {
        SUCCESS: 'SUCCESS' as ResultEnum,
        FAILURE: 'FAILURE' as ResultEnum,
        WARNING: 'WARNING' as ResultEnum
    };
    export type TypeEnum = 'IDENTIFICATION' | 'SCOPE1' | 'SCOPE2' | 'CONTENT' | 'VALIDATION';
    export const TypeEnum = {
        IDENTIFICATION: 'IDENTIFICATION' as TypeEnum,
        SCOPE1: 'SCOPE1' as TypeEnum,
        SCOPE2: 'SCOPE2' as TypeEnum,
        CONTENT: 'CONTENT' as TypeEnum,
        VALIDATION: 'VALIDATION' as TypeEnum
    };
}